'use client';

import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { CART_QUERY_KEYS } from '@skin-seoul/service/src/infrastructure/cart/utils/keys';

/**
 * CartInvalidationBridge component
 *
 * Sets up a global bridge function that allows the mobile app to invalidate
 * the webapp's cart query when the user returns from the mobile cart screen.
 *
 * This ensures that cart data stays in sync between the mobile native cart
 * and the webapp cart displayed in the webview.
 */
export function CartInvalidationBridge() {
  const queryClient = useQueryClient();
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    // Define the cart closed handler for mobile to call
    (window as any).__ssCartClosed = () => {
      queryClient.invalidateQueries({
        queryKey: CART_QUERY_KEYS.default()
      });
    };
    return () => {
      delete (window as any).__ssCartClosed;
    };
  }, [queryClient]);
  return null;
}